import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store, Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { MatDialogRef } from "@angular/material";
import { Actions } from '@ngrx/effects';
import { Observable, Subscription } from 'rxjs';

import * as actions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from '../customer.module.config';
import { AddGroupModel } from '../models/AddGroupModel';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'brd-add-group-dialog',
  templateUrl: './add-group-dialog.component.html',
  styleUrls: ['./add-group-dialog.component.scss']
})
export class AddGroupDialogComponent implements OnInit, OnDestroy {
  addForm: FormGroup;
  eventUnsubscribe: Subscription;
  errors$: Observable<string[]>;

  constructor(private store: Store<any>,
    public dialogRef: MatDialogRef<AddGroupDialogComponent>,
    private formBuilder: FormBuilder,
    private router: Router,
    private actions$: Actions) {
    this.addForm = formBuilder.group({
      name: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.eventUnsubscribe = this.actions$.ofType(actions.addSuccessType<AddGroupModel>(ModuleConfiguration.moduleName, AddGroupModel))
      .subscribe((a: actions.AddSuccessAction<AddGroupModel>) => {
        this.router.navigateByUrl('group-workspace/' + a.payload.key);
        this.close();
      });
  }

  ngOnDestroy(): void {
    if (this.eventUnsubscribe) {
      this.eventUnsubscribe.unsubscribe();
    }
  }

  add() {
    this.store.dispatch(new actions.AddAction(ModuleConfiguration.moduleName, AddGroupModel, { model: this.addForm.value }));
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/customer/components/add-group-dialog.component.ts